import { Box, CircularProgress, Typography } from '@mui/material';

type LoadingStateProps = {
  label?: string;
  minHeight?: number;
};

const LoadingState = ({
  label = 'Loading workspace…',
  minHeight = 240,
}: LoadingStateProps) => (
  <Box
    sx={{
      minHeight,
      display: 'grid',
      placeItems: 'center',
      gap: 1,
      color: 'text.secondary',
    }}
  >
    <CircularProgress size={28} />
    <Typography variant="body2" color="text.secondary">
      {label}
    </Typography>
  </Box>
);

export default LoadingState;
